.banner {
    max-width: 100%;
    margin: 0 auto;
    border-radius: var(--border-large);
}
.image {
    border-radius: var(--border-large);
    width: 100%;
    max-height: 100%;
}